import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const EPISODE_CAPTURE_IMAGE_ENDPOINT = 'api/v1/admin/episode_capture_images';


function searchEpisodeCaptureImage(params: any) {
    return api.get(`${baseUrl}/${EPISODE_CAPTURE_IMAGE_ENDPOINT}`, params);
}


export {
    searchEpisodeCaptureImage,
};